import { useCallback, useEffect, useRef, useState } from "react";
import appLogger from "../../../infra/logger/appLogger";
import clientStorage from "../../../services/clientStorage";
const logger = appLogger.withTag("RulebookHud");
/** Per viewer, all chats: whether the top meter panel is collapsed into the floating chip. */
const STORAGE_KEY = "rulebook.hud.minimized";
const MINIMIZED = "1";
const logStorageError = (error) => logger.warn("Could not save the meter panel state", error);
/** The panel's minimized state, remembered in this browser; storage failures keep it for this page only. */
export default function useHudMinimized() {
    const [stateIsMinimized, setStateIsMinimized] = useState(false);
    // Set once the viewer toggles: a saved preference that arrives later must not undo their choice.
    const refHasChosen = useRef(false);
    useEffect(() => {
        let isCurrent = true;
        clientStorage
            .getItem(STORAGE_KEY)
            .then((stored) => {
            if (isCurrent && !refHasChosen.current && stored === MINIMIZED) {
                setStateIsMinimized(true);
            }
        })
            .catch(logStorageError);
        return () => {
            isCurrent = false;
        };
    }, []);
    const setIsMinimized = useCallback((isMinimized) => {
        refHasChosen.current = true;
        setStateIsMinimized(isMinimized);
        (isMinimized ? clientStorage.setItem(STORAGE_KEY, MINIMIZED) : clientStorage.removeItem(STORAGE_KEY)).catch(logStorageError);
    }, []);
    return { isMinimized: stateIsMinimized, setIsMinimized };
}
